import { DrawMatch } from '../_interfaces'

export function isMatchBye(match: DrawMatch): boolean {
    const { team1, team2 } = match
    return team1.player1 && team1.player1.is_bye || team2.player1 && team2.player1.is_bye ? true : false
}